import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PoolSelector from 'components/PoolSelector'
import SupplyButton from 'components/Buttons/SupplyButton'

import { usePaladin } from 'hooks'
import { useAppState } from 'state'
import { weiToNum } from 'toolbelt'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40%',
    margin: 'auto',
    border: '1px solid #A5A5A5',
    borderRadius: '4px',
    marginTop: '5rem',
  },
  form: {
    width: '65%',
    margin: 'auto',
    marginTop: '3.5rem',
    marginBottom: '1.5rem',
  },
  label: {
    marginTop: '2rem',
    marginBottom: '.5rem',
  },
  text: {
    marginTop: '.2rem',
    marginBottom: '.4rem',
  },
  votingPower: {
    display: 'flex',
    flexDirection: 'row',
  },
  votingInput: {
    width: '205px',
    height: '35px',
  },
  max: {
    marginLeft: '1rem',
    alignSelf: 'center',
    color: '#A5A5A5',
    fontSize: 14,
    cursor: 'pointer',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    color: '#A5A5A5',
  },
  fee: {
    width: '70%',
  },
  feeInput: {
    width: '100%',
  },
  feeBalance: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  feeInfoTitle: {
    color: '#A5A5A5',
    fontSize: 12,
  },
  feeInfo: {
    color: '#A5A5A5',
    fontSize: 12,
    marginLeft: '1rem',
  },
  borrow: {
    margin: 'auto',
    marginTop: '2rem',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
}))

const DepositTab = () => {
  const styles = useStyles()
  const { aaveBalance } = useAppState()
  const { deposit, getAPY } = usePaladin()
  const [input, setInput] = React.useState('')
  const [apy, setAPY] = React.useState('')

  React.useEffect(() => {
    getAPY().then((res) => {
      res && console.log(`got ${weiToNum(res)}`)
      if (res) setAPY(weiToNum(res))
    })
  }, [])

  return (
    <Box>
      <PoolSelector isBorrow={false} />
      <Typography className={styles.label}>Input</Typography>
      <Box className={styles.fee}>
        <input className={styles.votingInput} value={input} onChange={(e) => setInput(e.target.value)}></input>
        <Box className={styles.feeBalance}>
          <Typography className={styles.feeInfoTitle}>Wallet Balance</Typography>
          <Typography className={styles.feeInfo}>{weiToNum(aaveBalance)} AAVE</Typography>
        </Box>
      </Box>
      {apy && (
        <>
          <Typography className={styles.label}>APY</Typography>
          <Typography className={styles.text}>{(parseFloat(apy) * 100).toFixed(3)}%</Typography>
        </>
      )}
      <Box className={styles.borrow}>
        <SupplyButton
          onClick={() => {
            deposit(input)
          }}
        >
          Supply
        </SupplyButton>
      </Box>
    </Box>
  )
}

export default DepositTab
